import LandingPageForm from "pages/ManagementPage/LandingPageForm/LandingPageForm";

export default LandingPageForm;
